import React, { useEffect } from 'react';
import { trackNaverConversion } from '../../utils/submitGuard';
import './SuccessPage.css';

const TITLES = {
  consult: '고객님의 상담 신청이 완료되었습니다.',
  schedule: '고객님의 상담 예약이 완료되었습니다.',
  estimate: '고객님의 견적 신청이 완료되었습니다.',
  question: '고객님의 질문이 등록되었습니다.'
};

// 네이버 전환유형: 4 = 신청/예약, 5 = 기타(질문)
const CONVERSION_TYPE = { consult: '4', schedule: '4', estimate: '4', question: '5' };

const SuccessPage = () => {
  const kind = new URLSearchParams(window.location.search).get('type') || 'consult';

  useEffect(() => {
    // 실제로 신청하고 넘어온 경우에만 1번 전환 기록 (새로고침·직접 접속은 제외)
    let fromSubmit = null;
    try {
      fromSubmit = sessionStorage.getItem('salt-conversion');
      sessionStorage.removeItem('salt-conversion');
    } catch (e) { /* 무시 */ }
    if (fromSubmit) {
      const fire = () => trackNaverConversion(CONVERSION_TYPE[fromSubmit] || '4', '1');
      if (window.wcs) fire(); else window.addEventListener('load', fire, { once: true });
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="salt-thankyou">
      <div className="salt-thankyou-inner">
        <h2>{TITLES[kind] || TITLES.consult}</h2>
        <h3>솔트CCTV의 상담 전문가가 빠른 시일 내에 연락드릴 예정입니다.</h3>
        <a href="/" className="salt-thankyou-home">메인페이지로 돌아가기</a>
      </div>
    </div>
  );
};

export default SuccessPage;
